/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum BusinessFunction {
    FinanceControl = 'FINANCE & CONTROL',
    Voyage = 'VOYAGE',
    CommunicationsBranding = 'COMMUNICATIONS & BRANDING',
    HumanResources = 'HUMAN RESOURCES',
    MarineSystems = 'MARINE SYSTEMS',
    EnergyBusiness = 'ENERGY BUSINESS',
    EnergyStorageBusiness = 'ENERGY STORAGE BUSINESS',
    CorporateRelationsLegal = 'CORPORATE RELATIONS & LEGAL',
    Marine = 'MARINE',
    PortfolioBusinesses = 'PORTFOLIO BUSINESSES',
    Shape = 'SHAPE',
    UvtAdminBusiness = 'UVT ADMIN BUSINESS',
    WrtsilCorporation = 'WÄRTSILÄ CORPORATION',
    Unknown = 'Unknown'
}

export function BusinessFunctionFromJSON(json: any): BusinessFunction {
    return BusinessFunctionFromJSONTyped(json, false);
}

export function BusinessFunctionFromJSONTyped(json: any, _: boolean): BusinessFunction {
    return json as BusinessFunction;
}

export function BusinessFunctionToJSON(value?: BusinessFunction | null): any {
    return value as any;
}
